/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlannedYieldResponse } from '../../models/planned-yield-response';

export interface GetPlannedYield$Params {
  location_id: string;

/**
 * ISO-8601 timestamp with offset, inclusive
 */
  from?: string;

/**
 * ISO-8601 timestamp with offset, exclusive
 */
  to?: string;
}

export function getPlannedYield(http: HttpClient, rootUrl: string, params: GetPlannedYield$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedYieldResponse>> {
  const rb = new RequestBuilder(rootUrl, getPlannedYield.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlannedYieldResponse>;
    })
  );
}

getPlannedYield.PATH = '/locations/{location_id}/energy-forecasts/yield';
